import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Folder } from 'src/app/interfaces/folder';
import { FolderService } from 'src/app/services/api/folder.service';
import { ErrorService } from 'src/app/services/error.service';
import { UserService } from 'src/app/services/user.service';
import { FolderEditComponent } from '../modals/folder-edit/folder-edit.component';

@Component({
  selector: 'app-settings-folders',
  templateUrl: './settings-folders.component.html',
  styleUrls: ['./settings-folders.component.scss']
})
export class SettingsFoldersComponent implements OnInit {

    public errorMessage: string = '' ;
    public errorType: string = '';

    public folders! : Folder[];

    constructor(private userService: UserService,
                private modalService: NgbModal,
                private errorService: ErrorService,
                private route: Router,
                private translate: TranslateService,
                private folderService: FolderService) {
        this.folders = this.userService.currentUser.symfonyUser.folders;
     }

    ngOnInit(): void {
        this.folderService.getFolders().subscribe(
            (res) => {
                this.folders = res.content;
            }, (resError) => {
                this.errorService.errorType = "ERROR";
                this.errorService.errorMessage = resError.error.detail;
                this.route.navigate(['/error']);
            }
        );
    }

    addFolder(folderIndex: number, folder: Folder, folderName: string) {
        this.folderService.addFolder(folder.id, folderName).subscribe((res) => {
            if (res.result == 'SUCCESS') {
                this.folders[folderIndex] = res.content;
                this.errorMessage = "SETTINGS.FOLDERS.CREATE";
                this.errorType = res.result;
            } else {
                this.errorMessage = res.content;
                this.errorType = res.result;
            }
        });
    }

    updateFolder(subfolder: Folder) {
        const modalRef = this.modalService.open(FolderEditComponent, {size: 'lg', centered: true});
        modalRef.componentInstance.folder = subfolder;

        modalRef.result.then((data) => {
            if (data) {
                subfolder.title = data;
            }
        }, (reason) => {});
    }

    deleteFolder(parentFolderIndex: number, subfolder: Folder) {
        var parentFolderNameTranslate = '';
        switch (subfolder.type) {
            case 'sending':
                parentFolderNameTranslate = "MESSAGES.FOLDER-SENDING";
            break;
            case 'trash':
                parentFolderNameTranslate = "MESSAGES.FOLDER-TRASH";
            break;
            case 'draft':
                parentFolderNameTranslate = "MESSAGES.FOLDER-DRAFT";
            break;
            default:
                parentFolderNameTranslate = subfolder.parent.title;
            break
        }

        this.translate.get(["SETTINGS.FOLDERS.CONFIRM-DELETE", parentFolderNameTranslate], {title: subfolder.title}).subscribe((res: string) => {
            const resArray = Object.values(res);
            const phraseConfirm = resArray[0] + " " + resArray[1];
            if (confirm(phraseConfirm)) {
                this.folderService.deleteFolder(subfolder.id).subscribe((res) => {
                    if (res.result == 'SUCCESS') {
                        this.folders[parentFolderIndex] = res.content;
                        this.errorMessage = "SETTINGS.FOLDERS.DELETE";
                        this.errorType = res.result;
                    } else {
                        this.errorMessage = res.content;
                        this.errorType = res.result;
                    }
                });
            }
        });
    }

}
